export default {
  bagFees: 'Es können weitere Gepäckgebühren anfallen',
}
